<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtrele</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbaslangic"
              v-model="datepickerbaslangic"
              local="en"
              today-variant="danger"
              :placeholder="placeholderbaslangic"
            />
          </b-col>

          <b-col lg="3" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="getOrderList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>

          <b-col lg="1" sm="5">
            <vs-button style="border-radius: 5px" @click="getOrderList()"
              >Listele</vs-button
            >
          </b-col>
          <b-col lg="3" sm="5">
            <vs-button
              style="border-radius: 5px"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              @click="kargoSecimi()"
              >Kargoya Gönder</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>

    <vs-card style="min-height: 250px">
      <vue-good-table
        @on-selected-rows-change="selectionChanged"
        :row-style-class="rowStyleClassFn"
        v-model="checkSelected"
        :columns="columns"
        :rows="orderList"
        :rtl="dir"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <div v-if="props.column.field === 'productCode'" class="text-nowrap">
            <b-avatar :src="sistemurl + props.row.images" class="mx-1" />
            <span class="text-nowrap">{{ props.row.productCode }}</span>
          </div>
          <div v-else-if="props.column.field === 'city'" class="text-nowrap">
            <span class="text-nowrap">{{ props.row.city }}</span>
          </div>
          <div
            v-else-if="props.column.field === 'OrderDate'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{
              parseDate(props.row.OrderDate)
            }}</span>
          </div>
          <span v-else-if="props.column.field === 'action'" style="width: 85px">
            <span>
              <b-row>
                <b-col lg="6" sm="12">
                  <vs-button
                    @click="getOrderListDetay(props.row.OrderNumber)"
                    size="small"
                    icon="search"
                    type="gradient"
                    style="border-radius: 5px"
                  ></vs-button>
                </b-col>
                <b-col lg="6" sm="12">
                  <vs-button
                    @click="recete(props.row.stokKodu)"
                    size="small"
                    icon="local_shipping"
                    type="gradient"
                    style="border-radius: 5px"
                  ></vs-button>
                </b-col>
              </b-row>
            </span>
          </span>

          <!-- Column: Status -->
        </template>
      </vue-good-table>
    </vs-card>
    <vs-prompt
      title="Kullanıcıyı Görevlendir"
      acceptText="Gönder"
      cancelText="Vazgeç"
      :active.sync="activePrompt"
      @accept="sendtoKargo"
    >
      <div class="con-exemple-prompt">
        <span>Kargo seçimi</span>
        <b-row>
          <b-col>
            <v-select
              v-model="secilenKargo"
              :options="optionsKargolar"
              label="adSoyad"
              style="width: 220px"
            ></v-select>
          </b-col>
        </b-row>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import moment from "moment";
import userJson from "../../../public/user.json";
import vSelect from "vue-select";
export default {
  data() {
    return {
      secilenKargo: "",
      activePrompt: false,
      optionsKargolar: ["MNG", "Aras"],
      sehirler: [
        "Adana",
        "Adıyaman",
        "Afyon",
        "Ağrı",
        "Amasya",
        "Ankara",
        "Antalya",
        "Artvin",
        "Aydın",
        "Balıkesir",
        "Bilecik",
        "Bingöl",
        "Bitlis",
        "Bolu",
        "Burdur",
        "Bursa",
        "Çanakkale",
        "Çankırı",
        "Çorum",
        "Denizli",
        "Diyarbakır",
        "Edirne",
        "Elazığ",
        "Erzincan",
        "Erzurum",
        "Eskişehir",
        "Gaziantep",
        "Giresun",
        "Gümüşhane",
        "Hakkari",
        "Hatay",
        "Isparta",
        "İçel (Mersin)",
        "İstanbul",
        "İzmir",
        "Kars",
        "Kastamonu",
        "Kayseri",
        "Kırklareli",
        "Kırşehir",
        "Kocaeli",
        "Konya",
        "Kütahya",
        "Malatya",
        "Manisa",
        "Kahramanmaraş",
        "Mardin",
        "Muğla",
        "Muş",
        "Nevşehir",
        "Niğde",
        "Ordu",
        "Rize",
        "Sakarya",
        "Samsun",
        "Siirt",
        "Sinop",
        "Sivas",
        "Tekirdağ",
        "Tokat",
        "Trabzon",
        "Tunceli",
        "Şanlıurfa",
        "Uşak",
        "Van",
        "Yozgat",
        "Zonguldak",
        "Aksaray",
        "Bayburt",
        "Karaman",
        "Kırıkkale",
        "Batman",
        "Şırnak",
        "Bartın",
        "Ardahan",
        "Iğdır",
        "Yalova",
        "Karabük",
        "Kilis",
        "Osmaniye",
        "Düzce",
      ],
      secilenStok: [],
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      arananDeger: "",
      orderList: [],
      dir: false,
      checkSelected: "",
      columns: [
        {
          label: "İşlem",
          field: "Islem",
        },
        {
          label: "Cari Kodu",
          field: "CurrAccCode",
        },
        {
          label: "Cari Adı",
          field: "FullName",
        },

        {
          label: "Sipariş Numarası",
          field: "OrderNumber",
        },
        {
          label: "Sipariş Tarihi",
          field: "OrderDate",
        },
        {
          label: "Evrak Numarası",
          field: "EvrakNo",
        },
        {
          label: "Açıklama",
          field: "Description",
        },

        {
          label: "Adres",
          field: "adres",
        },
        {
          label: "Şehir",
          field: "cityName",
        },
        {
          label: "İlçe",
          field: "districtName",
        },
        {
          label: "Durum",
          field: "durum",
        },
        {
          label: "Kargo Numarası",
          field: "LineDescription",
        },
      ],
    };
  },
  methods: {
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    sehirDeger(sehir) {
      let sehirtanim = sehir.split(".");
      return this.sehirler[parseInt(sehirtanim[1]) - 1];
    },
    kargoSecimi() {
      this.activePrompt = true;
    },
    sendtoKargo() {
      const vs = this.$vs;
      var vm = this;
      var aranandate = vm.datepickerbaslangic;

      if (
        vm.datepickerbaslangic == "" ||
        vm.datepickerbaslangic == "Invalid date"
      ) {
        aranandate = vm.getNow();
        vm.datepickerbaslangic = aranandate;
      }
      if (this.secilenStok.length == 0)
        vs.notify({
          text: "Lütfen sipariş seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      if (this.secilenKargo == "")
        vs.notify({
          text: "Lütfen kargo seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      else {
        vs.loading({
          background: userJson.themeColor,
          color: "#fff",
          container: "#button-with-loading-yeni",
          scale: 0.45,
        });
        const soap = require("soap");
        const url = state.sistemAddress;
        vm.secilenStok.forEach((val, ind) => {
          const args = {
            token: Store.state.tokenId,
            orderNumber: val.EvrakNo,
            orderNumber2: val.Description,
            orderDate: aranandate,
            kargo: vm.secilenKargo,
          };
          soap.createClient(url, function (err, client) {
            client.kargoyaGonder(args, function (err, result) {
              try {
                vm.veriler = JSON.parse(result.kargoyaGonderResult);
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
                if (vm.veriler.response == "Ok") {
                  vs.notify({
                    text: vm.veriler.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                } else {
                  vs.notify({
                    text: vm.veriler.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                    fixed: true,
                  });
                }
              } catch (error) {
                console.log(result);
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
                vs.notify({
                  text: "Hata oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
        });
      }
    },
    getNow() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      const dateTime = date;
      return dateTime;
    },
    getOrderList() {
      var vm = this;
      var aranandate = vm.datepickerbaslangic;
      const soap = require("soap");
      const url = state.sistemAddress;

      if (
        vm.datepickerbaslangic == "" ||
        vm.datepickerbaslangic == "Invalid date"
      ) {
        aranandate = vm.getNow();
        vm.datepickerbaslangic = aranandate;
      }

      const args = {
        token: Store.state.tokenId,
        aranan: vm.arananDeger,
        orderDate: aranandate,
      };
      soap.createClient(url, function (err, client) {
        client.B2B_OrderKargoList(args, function (err, result) {
          if (result.B2B_OrderKargoListResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
          try {
            vm.veriler = JSON.parse(result.B2B_OrderKargoListResult);
            vm.orderList = vm.veriler;
          } catch (error) {
            console.log(result);
          }
        });
      });
    },
    rowStyleClassFn(row) {
      if(row.durum==5)
      return "VGT-row";
    },
    selectionChanged(params) {
      //  alert("in")
      //  Store.state.uzum.secilenStokListTopluIslem = params.selectedRows;
      this.secilenStok = params.selectedRows;
    },
  },
  components:{
    "v-select": vSelect,
  },
  created() {
    this.getOrderList();
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}
</style>